import React from 'react';

import { Divider, Modal } from 'antd';
const CustomModal = ({ children, ...props }) => {
  return (
    <Modal
      style={{
        top: 20,
      }}
      maskClosable={false}
      {...props}
    >
      <Divider />
      {children}
    </Modal>
  );
};
export default CustomModal;
